import React  from 'react';
function GoldZakatTable({ result }) {
  return (
    <table >
      <thead>
        <tr>
          <th >Status</th>
          <th >Results</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Zakat Obligation</td>
          <td>{result.goldZakatDuty === 'yes' ? 'You are obligated to pay Zakat' : 'You are not obligated to pay Zakat'}</td>
        </tr>
        <tr >
          <td>Net Gold Weight</td>
          <td>{result.totalPureGoldWeight} (g)</td>
        </tr>
        <tr >
          <td>Gold Zakat Threshold</td>
          <td>{result.goldWeightThreshold} (g)</td>
        </tr>
        <tr >
          <td>Amount of Zakat to Be Paid (in currency)</td>
          <td>{result.moneyZakatAmount}</td>
        </tr>
        <tr >
          <td>Amount of Zakat to Be Paid (in gold)</td>
          <td>{result.goldZakatAmount} (g)</td>
        </tr>
      </tbody>
    </table>
  );
}
export default GoldZakatTable;
